import { PostHogProvider } from 'posthog-js/react'

import { useEnv } from '../hooks/env';
import { useTracking } from '../hooks/tracking';
import { lfLog } from '../components/lets-form/helpers/lf-log';

export const AnalyticsProvider = ({ children, ...rest }) => {
  const { DEVELOPMENT_ENABLE_POSTHOG, POSTHOG_API_KEY } = useEnv();
  const { getCookieConsent } = useTracking();

  if (process.env.NODE_ENV !== 'development' || DEVELOPMENT_ENABLE_POSTHOG === 'true') {
    const consent = getCookieConsent() === 'yes';
    if (consent) {
      lfLog('Cookie consent given, analytics is enabled');
    }
    return (
      <PostHogProvider
        apiKey={POSTHOG_API_KEY}
        options={{
          api_host: 'https://app.posthog.com',
          persistence: consent ? 'localStorage+cookie' : 'memory'
        }}
        {...rest}
      >
        {children}
      </PostHogProvider>
    );
  } else {
    return <>{children}</>;
  }
};